import { SupplierStorefrontV2GetResponseType } from "@sellar-io/api-v2/types";
import dayjs from "dayjs";
import { getNextDirectDeliveryDate } from "../pages/order/helpers/DeliveryDateHelpers/getNextDeliveryDate";
import { getOrderByDateTime } from "../pages/order/helpers/DeliveryDateHelpers/getOrderByDate";

export const useEstimateDirectDeliveryDate = (params: {
  deliveryArea?: SupplierStorefrontV2GetResponseType["DeliveryArea"];
  startDateReference: Date; // date from which the order can start being dispatched from
}): {
  nextDeliveryDate: dayjs.Dayjs | null;
  orderByDate: dayjs.Dayjs | null;
} => {
  const { deliveryArea, startDateReference } = params;

  const nextDeliveryDates = deliveryArea
    ? getNextDirectDeliveryDate({
        deliveryArea,
        startDateReference,
      })
    : null;

  // supplier is direct or within pickup area, use schedule cutoff date/time

  const orderByDate = getOrderByDateTime({
    nextDeliveryDate: nextDeliveryDates?.deliveryDate ?? null,
    orderCutOffTime: deliveryArea?.orderCutOffTime ?? null,
    orderCutOffDaysBefore: deliveryArea?.orderCutOffDaysBefore ?? null,
    includeWeekend: deliveryArea?.includeWeekend ?? true,
  });

  return {
    nextDeliveryDate: nextDeliveryDates
      ? dayjs(nextDeliveryDates.deliveryDate)
      : null,
    orderByDate,
  };
};
